// General
import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal } from 'react-bootstrap';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { closeWishListGroupModal } from '../../../actions/WishList/modalActions';


// Translation
import { FormattedMessage } from 'react-intl';

// Locale
import messages from '../../../locale/messages';

// Component
import AddWishListGroupForm from '../WishListGroupForm/AddWishListGroupForm';
import EditWishListGroupForm from '../EditWishListGroupForm';

import bt from '../../../components/commonStyle.css';
import s from './WishListGroupModal.css';

const WishListGroupModal = ({ actionType }) => {

  const dispatch = useDispatch();
  const wishListGroupModal = useSelector(state => state.modalStatus.wishListGroupModalOpen);

  return (
    <div>
      <Modal show={wishListGroupModal} onHide={() => dispatch(closeWishListGroupModal())} dialogClassName={'loginModal'} >
        <Modal.Header closeButton>
          <Modal.Title><FormattedMessage {...messages.wishList} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass={s.logInModalBody}>
          <div className={s.root}>
            <p className={bt.commonLabelText}>
              {
                actionType != 'edit' && <FormattedMessage {...messages.createWishList} />
              }
              {
                actionType == 'edit' && <FormattedMessage {...messages.editWishList} />
              }
            </p>
            <div>
              {
                actionType != 'edit' && <AddWishListGroupForm />
              }
              {
                actionType == 'edit' && <EditWishListGroupForm />
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

WishListGroupModal.propTypes = {
  closeWishListGroupModal: PropTypes.any,
  wishListGroupModal: PropTypes.bool,
  actionType: PropTypes.string
};

export default withStyles(bt, s)(WishListGroupModal);
